export function facebookSDKInit(appId: string) {
  const callbackWait = new Promise<boolean>((resolve) => {
    // @ts-ignore
    window.fbAsyncInit = () => {
      // @ts-ignore
      FB.init({
        appId,
        xfbml: true,
        version: 'v19.0',
      })
      resolve(true)
    }
  })

  const script = document.createElement('script')
  script.src = `https://connect.facebook.net/en_US/sdk.js`
  script.async = true
  script.defer = true
  script.crossOrigin = 'anonymous'
  document.head.appendChild(script)

  return callbackWait
}
